var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sh-inliner',{staticClass:"file-media__item__header"},[_vm._t("default"),_vm._v("\n   \n  "),(!_vm.disabled)?_c('el-button',{attrs:{"icon":"el-icon-circle-plus","type":"text"}},[_vm._v("Add")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b5dc02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submission/steps/FilesMedia/FileMediaItemHeader.vue
// module id = 789
// module chunks = 6